import moment from 'moment';

export const dateFormat = (date, format = 'MMMM, Do YYYY') =>
  moment(date).format(format);

export function dateOfWeeks({ startWeek = 'monday', limit = 6, addition = 7 }) {
  const day = moment().day(startWeek);

  return [...Array(limit).keys()].reduce(
    acc => [...acc, moment(day.subtract(addition, 'd'))],
    [],
  );
}
